import { Ionicons } from '@expo/vector-icons';
import * as Clipboard from 'expo-clipboard';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Pressable, StyleSheet, Text } from 'react-native';

import { fontSize, radius, spacing } from '@/constants/theme';
import type { AppColors } from '@/constants/theme';
import { useTheme } from '@/contexts/ThemeContext';
import { formatUserId } from '@/lib/format';

/** Δείχνει το UserID (HEI-00123) με κουμπί αντιγραφής. */
export function UserIdChip({ userNumber }: { userNumber: number | null | undefined }) {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const styles = useMemo(() => makeStyles(colors), [colors]);
  const [copied, setCopied] = useState(false);
  const id = formatUserId(userNumber);

  async function copy() {
    try {
      await Clipboard.setStringAsync(id);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // αγνόησε
    }
  }

  return (
    <Pressable style={styles.chip} onPress={copy} accessibilityRole="button" accessibilityLabel={t('userIdChip.copyAccessibilityLabel')}>
      <Text style={styles.label}>User ID: </Text>
      <Text style={styles.id}>{id}</Text>
      <Ionicons name={copied ? 'checkmark' : 'copy-outline'} size={16} color={colors.primary} />
    </Pressable>
  );
}

function makeStyles(colors: AppColors) {
  return StyleSheet.create({
    chip: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: spacing.sm,
      alignSelf: 'center',
      backgroundColor: colors.surfaceAlt,
      borderRadius: radius.full,
      paddingVertical: 6,
      paddingHorizontal: spacing.md,
    },
    label: {
      color: colors.textMuted,
      fontSize: fontSize.sm,
      fontWeight: '500',
    },
    id: {
      color: colors.text,
      fontSize: fontSize.md,
      fontWeight: '700',
      letterSpacing: 1,
    },
  });
}
